var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 111,
    viewBox: "0 0 131 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.13401 0 0 3.13401 0 7V86C0 89.866 3.134 93 7 93H86.6667L104.993 109.494C106.924 111.231 110 109.861 110 107.264V93H124C127.866 93 131 89.866 131 86V7C131 3.13401 127.866 0 124 0H7Z",
    fill: "#FEF8F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27H105",
    stroke: "#777777",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40H105",
    stroke: "#777777",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53H105",
    stroke: "#777777",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66H60",
    stroke: "#777777",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScript);
export default __webpack_public_path__ + "static/media/Script.726205ae48488574827e0cd20ab94761.svg";
export { ForwardRef as ReactComponent };